<template>
  <div>
    <div class="font-weight-medium mb-2">Spacing</div>
    <v-row>
      <v-col cols="3">
        <div class="d-flex align-end">
          <v-text-field
            :value="safeFields.topDesktop"
            label="Desktop Top Spacing"
            type="number"
            min="0"
            step="1"
            @input="value => handlePaddingInput('topDesktop', value)"
            @blur="() => handlePaddingBlur('topDesktop')"
            hide-details
            suffix="px"
          />
          <v-btn class="ml-2" small depressed color="primary" text @click="handlePaddingReset('topDesktop')"
            >Reset</v-btn
          >
        </div>
      </v-col>
      <v-col cols="3">
        <div class="d-flex align-end">
          <v-text-field
            :value="safeFields.bottomDesktop"
            label="Desktop Bottom Spacing"
            type="number"
            min="0"
            step="1"
            @input="value => handlePaddingInput('bottomDesktop', value)"
            @blur="() => handlePaddingBlur('bottomDesktop')"
            hide-details
            suffix="px"
          />
          <v-btn class="ml-2" small depressed color="primary" text @click="handlePaddingReset('bottomDesktop')"
            >Reset</v-btn
          >
        </div>
      </v-col>
      <v-col cols="3">
        <div class="d-flex align-end">
          <v-text-field
            :value="safeFields.topMobile"
            label="Mobile Top Spacing"
            type="number"
            min="0"
            step="1"
            @input="value => handlePaddingInput('topMobile', value)"
            @blur="() => handlePaddingBlur('topMobile')"
            hide-details
            suffix="px"
          />
          <v-btn class="ml-2" small depressed color="primary" text @click="handlePaddingReset('topMobile')"
            >Reset</v-btn
          >
        </div>
      </v-col>
      <v-col cols="3">
        <div class="d-flex align-end">
          <v-text-field
            :value="safeFields.bottomMobile"
            label="Mobile Bottom Spacing"
            type="number"
            min="0"
            step="1"
            @input="value => handlePaddingInput('bottomMobile', value)"
            @blur="() => handlePaddingBlur('bottomMobile')"
            hide-details
            suffix="px"
          />
          <v-btn class="ml-2" small depressed color="primary" text @click="handlePaddingReset('bottomMobile')"
            >Reset</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SectionPadding',
  props: {
    fields: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    resetPadding: {
      type: Object,
      required: false,
      default: () => ({ topDesktop: 0, bottomDesktop: 0, topMobile: 0, bottomMobile: 0 }),
    },
  },
  computed: {
    safeFields() {
      return {
        topDesktop: this.fields.topDesktop ?? 0,
        bottomDesktop: this.fields.bottomDesktop ?? 0,
        topMobile: this.fields.topMobile ?? 0,
        bottomMobile: this.fields.bottomMobile ?? 0,
      };
    },
  },
  methods: {
    normalizePaddingValue(value) {
      if (value === null || value === undefined || value === '') return '';

      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) {
        const cleaned = String(value).replace(/[^\d]/g, '');
        return cleaned === '' ? '' : Number(cleaned);
      }

      if (numericValue < 0) return 0;
      return Math.floor(numericValue);
    },
    handlePaddingInput(key, value) {
      const nextValue = this.normalizePaddingValue(value);
      this.$set(this.fields, key, nextValue);
    },
    handlePaddingBlur(key) {
      const currentValue = this.normalizePaddingValue(this.fields[key]);
      this.$set(this.fields, key, currentValue === '' ? 0 : currentValue);
    },
    handlePaddingReset(key) {
      this.handlePaddingInput(key, this.resetPadding[key]);
    },
  },
};
</script>
